export const privacyText = `PRIVACY POLICY — OASI BAGNI
Informativa sul trattamento dei dati personali ai sensi degli articoli 13 e 14 del Regolamento (UE) 2016/679

Ultimo aggiornamento: 13 ottobre 2026

1. Titolare del trattamento

Il titolare del trattamento è DAVOM S.r.l., di cui Oasi Bagni è un brand, con sede legale in Via Rembrandt 69, 20147 Milano, P. IVA e codice fiscale 12938940967, REA MI-2694146.

Per informazioni sul trattamento dei dati o per esercitare i tuoi diritti puoi scrivere a:
Email: info@oasibagni.it
PEC: davomsrl@pec.it

2. Dati trattati e provenienza

Trattiamo i dati che ci comunichi quando richiedi informazioni, una guida, un sopralluogo o un preventivo attraverso il sito, i moduli pubblicitari di Facebook e Instagram, email, telefono o WhatsApp.

A seconda della richiesta, i dati possono comprendere nome e cognome, telefono, email, comune o indirizzo dell’intervento, informazioni sul bagno o sui lavori desiderati, budget indicativo, tempistiche e contenuto delle comunicazioni.

Quando compili un modulo su Facebook o Instagram, riceviamo tramite Meta i dati che scegli di inviare, compresi gli eventuali campi precompilati che confermi al momento dell’invio. I trattamenti svolti da Meta sulle proprie piattaforme sono descritti nelle informative di Meta.

Ti chiediamo di non inviare dati relativi alla salute o altre informazioni particolarmente sensibili non necessarie alla richiesta.

3. Finalità e basi giuridiche

Utilizziamo i tuoi dati per:

a) Rispondere alla richiesta, inviarti il materiale richiesto, ricontattarti, organizzare un sopralluogo, predisporre un preventivo e gestire i successivi chiarimenti relativi alla stessa richiesta. La base giuridica è l’esecuzione di misure precontrattuali adottate su tua richiesta, ai sensi dell’articolo 6, paragrafo 1, lettera b) del GDPR.

b) Se viene concluso un contratto, gestire il servizio, le comunicazioni operative e gli adempimenti amministrativi. Le basi giuridiche sono l’esecuzione del contratto e l’adempimento degli obblighi di legge, ai sensi dell’articolo 6, paragrafo 1, lettere b) e c) del GDPR.

c) Quando necessario, tutelare i diritti del titolare e gestire contestazioni. La base giuridica è il legittimo interesse alla tutela dei propri diritti, ai sensi dell’articolo 6, paragrafo 1, lettera f) del GDPR.

L’invio di una richiesta non comporta automaticamente l’iscrizione a newsletter o il consenso a campagne promozionali successive e indipendenti dalla richiesta. Tali attività, ove previste, richiedono una distinta informativa e, quando necessario, un consenso specifico e facoltativo.

4. Modalità di contatto e trattamento

Possiamo rispondere tramite telefono, email o WhatsApp utilizzando i recapiti che ci hai fornito, in relazione alla tua richiesta. Puoi comunicarci il canale che preferisci e chiedere di interrompere i ricontatti.

I dati sono gestiti con strumenti informatici e, quando necessario, documenti cartacei. L’accesso è limitato alle persone autorizzate in relazione alle attività da svolgere.

5. Conferimento dei dati

Fornire i dati è facoltativo. I campi indicati come obbligatori nei moduli sono necessari per gestire la richiesta: se non li fornisci, potremmo non riuscire a ricontattarti o a predisporre il servizio richiesto.

I dati richiesti esclusivamente per eventuali attività promozionali sono facoltativi e il loro mancato conferimento non impedisce di ottenere informazioni o preventivi.

6. Destinatari dei dati

I dati possono essere trattati da personale e collaboratori autorizzati di DAVOM S.r.l. e da fornitori che supportano la gestione delle richieste, i sistemi informatici, il CRM, le automazioni, la posta elettronica e le comunicazioni.

Nel processo di gestione dei contatti possono essere utilizzati Airtable per il CRM, Zapier per il trasferimento e l’automazione delle richieste, Zoho per la posta elettronica e WhatsApp Business per le comunicazioni.

I fornitori operano come responsabili del trattamento o titolari autonomi secondo il servizio svolto e gli accordi applicabili.

Quando necessario per il sopralluogo o il servizio richiesto, i dati pertinenti possono essere comunicati a tecnici, professionisti e imprese coinvolti nell’intervento. Possono inoltre essere comunicati a consulenti e autorità nei casi previsti dalla legge.

7. Trasferimenti fuori dallo Spazio economico europeo

L’impiego di piattaforme e fornitori tecnologici può comportare il trattamento di dati fuori dallo Spazio economico europeo.

Quando tali trasferimenti avvengono, devono essere effettuati secondo le condizioni previste dal GDPR, mediante una decisione di adeguatezza applicabile o altre garanzie appropriate, come le clausole contrattuali standard della Commissione europea.

Puoi richiedere al titolare informazioni sui trasferimenti relativi ai tuoi dati e sulle garanzie applicabili utilizzando i recapiti indicati sopra.

8. Conservazione dei dati

I dati relativi alle richieste sono conservati per il tempo necessario a rispondere, organizzare il sopralluogo, elaborare e discutere il preventivo e concludere la gestione della richiesta.

La durata viene valutata tenendo conto dello stato della richiesta, delle comunicazioni intercorse e dell’eventuale prosecuzione del rapporto. Una richiesta conclusa non giustifica, da sola, la conservazione indefinita dei dati per future attività promozionali.

Se viene concluso un contratto, i dati pertinenti sono conservati per la durata del rapporto e per i successivi periodi richiesti dagli obblighi di legge. I dati necessari alla gestione di una contestazione possono essere conservati per il tempo necessario alla tutela dei diritti.

9. I tuoi diritti

Nei casi e nei limiti previsti dal GDPR puoi chiedere l’accesso ai tuoi dati, la rettifica, la cancellazione, la limitazione del trattamento e la portabilità. Puoi opporti ai trattamenti fondati sul legittimo interesse.

Quando un trattamento si basa sul consenso, puoi revocarlo in qualsiasi momento, senza pregiudicare la liceità del trattamento effettuato prima della revoca.

Per esercitare i diritti scrivi a info@oasibagni.it o a davomsrl@pec.it. Se necessario, potremo richiedere informazioni utili a verificare la tua identità.

Hai inoltre il diritto di presentare reclamo al Garante per la protezione dei dati personali, secondo le modalità disponibili su www.garanteprivacy.it.

10. Decisioni automatizzate

Le automazioni usate per trasferire i contatti, organizzare le richieste o inviare conferme non costituiscono, di per sé, decisioni automatizzate con effetti giuridici o analogamente significativi sulla persona.

11. Ambito dell’informativa

Questa informativa disciplina la gestione delle richieste e dei contatti. Gli eventuali cookie, strumenti di analisi, pixel pubblicitari e altri tracciamenti del sito richiedono informazioni specifiche coerenti con la configurazione effettivamente utilizzata.`;
